import { NgModule } from '@angular/core';
import { RouterModule, Routes, Router } from '@angular/router';
import { LoginComponent } from '../pages/login/login.component';
import { AppLayoutComponent } from '../pages/app-layout/app-layout.component';
import { IntroductionComponent } from '../pages/introductionmodule/introductionmodule';
import { GetStartedComponentQR } from '../pages/getstartedmoduleqr/getstartedmoduleqr';
import { DownloadsComponent } from '../pages/downloads/downloads';
import { ClassModuleComponent as ClassModuleComponent } from '../pages/bleclassmodule/bleclassmodule';
import { EnumModuleComponent } from '../pages/enummodule/enummodule';
import { ExampleCardlessComponent } from '../pages/examplecardless/example-cardless-module';
import { GetStartedBLEComponent } from '../pages/getstartedmoduleble/getstartedmoduleble';
import { ExampleCashlessComponent } from '../pages/examplecashless/example-cashless-module';
import { ExampleAdvancedComponent } from '../pages/example-advanced/example-advanced-module';
import { RSSITablePage } from '../pages/rssitablemodule/rssi-table-page';
import { LandingModuleComponent } from '../pages/landingmodule/landingmodule.component';
import { GetStartedEdgeComponent } from '../pages/getstarted-edge-module/getstartededgemodule';
import { ExampleCashlessEdgeComponent } from '../pages/examplecashlessedge/example-cashlessedge-module';
import { ExampleQrComponent } from '../pages/exampleqr/example-qr-module';
/**
    * Configures Component Routes.
     */
    const routes: Routes = [
      { path: '', redirectTo: 'docs', pathMatch: 'prefix'  },
      { path: 'docs', component: LandingModuleComponent, pathMatch: 'prefix' },
      { path: 'sgconnect', component: AppLayoutComponent,
        children: [
          { path: '', redirectTo: 'introduction', pathMatch: 'prefix' },
          { path: 'introduction', component: IntroductionComponent, pathMatch: 'prefix' },
          { path: 'downloads', component: DownloadsComponent, pathMatch: 'prefix' },
          { path: 'getstartedqr', component: GetStartedComponentQR, pathMatch: 'prefix'},
          { path: 'getstartedble', component: GetStartedBLEComponent, pathMatch: 'prefix'},

          { path: 'classes-SGBLEConnect', component: ClassModuleComponent, data: {className:"SGConnectBLE"}, pathMatch : 'prefix' },
          { path: 'classes-SGConnectQR', component: ClassModuleComponent, data: {className:"SGConnectQR"}, pathMatch : 'prefix' },

          { path: 'interfaces-SGLogCallback', component: ClassModuleComponent, data: {className:"SGLoggerDelegate"}, pathMatch : 'prefix'  },
          { path: 'interfaces-SGBleStatusCallback', component: ClassModuleComponent, data: {className:"SGBLEObserver"}, pathMatch : 'prefix'  },
          { path: 'interfaces-SGProxStatusCallback', component: ClassModuleComponent, data: {className:"SGProxObserver"}, pathMatch : 'prefix'  },
          { path: 'interfaces-SGQRStatusCallback', component: ClassModuleComponent, data: {className:"SGQRStatusCallback"}, pathMatch : 'prefix'  },
          { path: 'interfaces-SGSessionStatusCallback', component: ClassModuleComponent, data: {className:"SGSessionObserver"}, pathMatch : 'prefix'  },
          { path: 'interfaces-SGPlayerProfileObserver', component: ClassModuleComponent, data: {className:"SGPlayerProfileObserver"}, pathMatch : 'prefix'  },
          { path: 'interfaces-SGPlayerBalanceCallback', component: ClassModuleComponent, data: {className:"SGPlayerBalanceCallback"}, pathMatch : 'prefix'  },
          { path: 'interfaces-SGFundTransferCallback', component: ClassModuleComponent, data: {className:"SGFundTransferCallback"}, pathMatch : 'prefix'  },

          { path: 'enums-SGBLEError', component: EnumModuleComponent, data: {type:"error", className:"SGBLEError"}, pathMatch : 'prefix'  },
          { path: 'enums-SGDeviceProximityError', component: EnumModuleComponent, data: {type:"error", className:"SGDeviceProximityError"}, pathMatch : 'prefix'  },
          { path: 'enums-SGPlayerSessionError', component: EnumModuleComponent, data: {type:"error", className:"SGPlayerSessionError"}, pathMatch : 'prefix'  },
          { path: 'enums-SGBalanceError', component: EnumModuleComponent, data: {type:"error", className:"SGBalanceError"}, pathMatch : 'prefix'  },
          { path: 'enums-SGPlayerProfileError', component: EnumModuleComponent, data: {type:"error", className:"SGPlayerProfileError"}, pathMatch : 'prefix'  },
          { path: 'enums-SGFundsTransferError', component: EnumModuleComponent, data: {type:"error",className:"SGFundsTransferError"}, pathMatch : 'prefix'  },
          { path: 'enums-SGQRError', component: EnumModuleComponent, data: {type:"error",className:"SGQRError"}, pathMatch : 'prefix'  },

          { path: 'enums-SGBLEConnectionState', component: EnumModuleComponent, data: {className:"SGBLEConnectionState"}, pathMatch : 'prefix'  },
          { path: 'enums-SGDeviceProximityState', component: EnumModuleComponent, data: {className:"SGDeviceProximityState"}, pathMatch : 'prefix'  },
          { path: 'enums-SGQRConnectionState', component: EnumModuleComponent, data: {className:"SGQRConnectionState"}, pathMatch : 'prefix'  },
          { path: 'enums-SGPlayerSessionState', component: EnumModuleComponent, data: {className:"SGPlayerSessionState"}, pathMatch : 'prefix'  },
          { path: 'enums-SGPlayerProfileState', component: EnumModuleComponent, data: {className:"SGPlayerProfileState"}, pathMatch : 'prefix'  },
          { path: 'enums-SGLogLevel',  component: EnumModuleComponent, data: {className:"SGLogLevel"}, pathMatch : 'prefix'  },

          { path: 'example-SGCardlessConnect', component: ExampleCardlessComponent },
          { path: 'example-SGQRConnect', component: ExampleQrComponent },
          { path: 'example-SGCashlessConnect', component: ExampleCashlessComponent },
          { path: 'example-Advanced', component: ExampleAdvancedComponent },
          { path: 'rssi-Table', component: RSSITablePage }

        ], pathMatch: 'prefix'
      },
      { path: 'sgconnectedge', component: AppLayoutComponent,
        children: [
          { path: '', redirectTo: 'getstartededgeble', pathMatch: 'prefix' },
          { path: 'getstartededgeble', component: GetStartedEdgeComponent, pathMatch: 'prefix'},
          { path: 'example-SGCashlessConnectEdge', component: ExampleCashlessEdgeComponent },
          { path: 'classes-SGBLEConnectEdge', component: ClassModuleComponent, data: {className:"SGConnectEdge"}, pathMatch : 'prefix' },
          { path: 'enums-SGBLEConnectionState', component: EnumModuleComponent, data: {className:"SGBLEConnectionState"}, pathMatch : 'prefix'  },
          { path: 'enums-SGLogLevel',  component: EnumModuleComponent, data: {className:"SGLogLevel"}, pathMatch : 'prefix'  },
          { path: 'enums-SGBLEError', component: EnumModuleComponent, data: {type:"error", className:"SGBLEError"}, pathMatch : 'prefix'  },
          { path: 'enums-SGChipTransactionError', component: EnumModuleComponent, data: {type:"error", className:"SGChipTransactionError"}, pathMatch : 'prefix'  },
          { path: 'interfaces-SGBleStatusCallback', component: ClassModuleComponent, data: {className:"SGBLEObserver"}, pathMatch : 'prefix'  },
          { path: 'interfaces-SGLogCallback', component: ClassModuleComponent, data: {className:"SGLoggerDelegate"}, pathMatch : 'prefix'  },
          { path: 'interfaces-SGFundTransferEdgeCallback', component: ClassModuleComponent, data: {className:"SGFundTransferEdgeCallback"}, pathMatch : 'prefix'  },
          { path: 'downloads', component: DownloadsComponent, pathMatch: 'prefix' },
        ]
      }

    ];

/**
    * Add each component and it's specific route.
    *
    * routes is an array of objects of type Routes.
    *
    *Each object corresponds to a path in the application, and must have at-least two parameters:
    a path to which the app will navigate (this will be shown in the URL) and a component to load for that corresponding path.
     */
@NgModule({
  imports: [
    RouterModule.forRoot(routes, {
      scrollPositionRestoration: 'enabled',
      anchorScrolling: 'enabled'
    })
  ],
  exports: [RouterModule]
})
export class AppRoutingModule { }

